import { render, staticRenderFns } from "./UnidentifiedPaymentsHead.vue?vue&type=template&id=4843a1a4&scoped=true"
import script from "./UnidentifiedPaymentsHead.vue?vue&type=script&lang=js"
export * from "./UnidentifiedPaymentsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843a1a4",
  null
  
)

export default component.exports